import { useMemo } from 'react';

import { randomStr } from '../../utils/helpers';

const useSection = () => {
  const titleId = useMemo(() => `section-title-${randomStr(6)}`, []);
  return { titleId };
};

export default useSection;
